// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "disturbance-frontend/js/" + chunkId + "." + "63161b026219f5fbbd40" + ".bundle.js";
};